import * as React from "react";
import { Menu, Tab as BaseTab, TabProps } from "semantic-ui-react";
import { COLORS } from "../../../constants";
import { Text } from "../text";

interface IAttachedTabNew extends TabProps {
  widths?: number;
}

class AttachedTabNew extends React.Component<IAttachedTabNew> {
  public state = { activeIndex: 0 };
  public render() {
    const { widths, panes, activeIndex, onTabChange, ...rest } = this.props;
    return (
      <React.Fragment>
        <style
          dangerouslySetInnerHTML={{
            __html: [
              `.ui.pointing.menu .active.item:after  {background-color:${COLORS.navyBlueDarkIIPM}}
                .ui.pointing.menu .active.item:hover:after {background-color:${COLORS.navyBlueDarkIIPM}}`,
            ].join("\n"),
          }}
        />
        <BaseTab
          menu={{
            attached: false,
            fluid: true,
            widths,
            pointing: true,
          }}
          panes={this.getPanes()}
          activeIndex={
            activeIndex !== undefined ? activeIndex : this.state.activeIndex
          }
          onTabChange={(e: any, data: any) => {
            this.setState({ activeIndex: data.activeIndex });
            if (onTabChange) {
              onTabChange(e, data);
            }
          }}
          {...rest}
        />
      </React.Fragment>
    );
  }

  private getPanes = () => {
    const { panes, activeIndex } = this.props;
    if (panes && panes.length > 0) {
      return panes.map((item, index) => {
        const active =
          activeIndex !== undefined ? activeIndex : this.state.activeIndex;
        const isActive = active === index;
        return {
          menuItem: (
            <Menu.Item
              key={index}
              style={{
                backgroundColor: isActive
                  ? COLORS.navyBlueDarkIIPM
                  : COLORS.transparent,
              }}
            >
              <Text
                style={{
                  color: isActive ? COLORS.white : COLORS.black,
                  fontWeight: isActive ? 'bold' : 'normal',
                }}
                // size="big"
              >
                {item.menuItem}
              </Text>
            </Menu.Item>
          ),
          render: item.render,
        };
      });
    } else {
      return [];
    }
  };
}

export default AttachedTabNew;
